import Layout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/ContentScripts/Details';
import { displayName } from '../../../config';

const ContentScriptDetails = (): JSX.Element => {
  document.title = `${displayName}: Content Script Details`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default ContentScriptDetails;
